import React from 'react';
import Modal from '../../components/modal/modal';
import idStyles from '../invoice_detail/invoiceDetailModal.module.css';

function CardRow({ label, children, span2, column, valueNowrap }) {
    return (
        <div
            className={`${idStyles.card} ${span2 ? idStyles.compactGridSpan2 : ''} ${
                column ? idStyles.cardCol : ''
            }`.trim()}
        >
            <div className={idStyles.label}>{label}</div>
            <div
                className={idStyles.value}
                style={valueNowrap ? { whiteSpace: 'nowrap' } : undefined}
            >
                {children}
            </div>
        </div>
    );
}

export default function GREViewModal({ show, setter, data }) {
    const conductorNombre = data?.conductor_principal?.nombre ?? '-';
    const conductorDni = data?.conductor_principal?.dni ?? '-';

    return (
        <Modal
            show={show}
            setter={setter}
            name="Detalle de GRE"
            size="xl"
            headerClassName={idStyles.headerPremium}
            titleClassName={idStyles.titlePremium}
            dialogClassName={idStyles.dialogWide}
        >
            <div className={idStyles.bodyWrap}>
                <div className={idStyles.modalSubtitle}>Detalle</div>
                <div className={idStyles.compactGrid}>
                    <CardRow label="Remitente:">{data?.remitente ?? '-'}</CardRow>
                    <CardRow label="Destinatario:">{data?.destinatario ?? '-'}</CardRow>
                    <CardRow label="Fecha de Emisión:">{data?.fecha_emision ?? '-'}</CardRow>
                    <CardRow label="Motivo:">{data?.desc_motivo ?? '-'}</CardRow>

                    <CardRow label="Peso Bruto:">{data?.peso_bruto ?? '-'}</CardRow>
                    <CardRow label="Unidad Peso Bruto:">{data?.unidad_peso_bruto ?? '-'}</CardRow>
                    <CardRow label="Punto Partida:">{data?.punto_partida ?? '-'}</CardRow>
                    <CardRow label="Punto Llegada:">{data?.punto_llegada ?? '-'}</CardRow>

                    <CardRow label="Modalidad:">{data?.datos_traslado?.modalidad ?? '-'}</CardRow>
                    <CardRow
                        label="Indicador de Transbordo Programado:"
                        valueNowrap
                    >
                        {data?.datos_traslado?.transbordo_programado ? 'Sí' : 'No'}
                    </CardRow>
                    <CardRow
                        label="Indicador de traslado en vehículos M1:"
                        valueNowrap
                    >
                        {data?.datos_traslado?.traslado_m1_l ? 'Sí' : 'No'}
                    </CardRow>
                    <CardRow label="Indicador retorno envases/embalajes vacíos:" valueNowrap>
                        {data?.datos_traslado?.envase_vacio ? 'Sí' : 'No'}
                    </CardRow>

                    <CardRow label="Indicador retorno vehículo vacío:" valueNowrap>
                        {data?.datos_traslado?.vechiculo_vacio ? 'Sí' : 'No'}
                    </CardRow>
                    <CardRow label="Indicador traslado total DAM o DS:" valueNowrap>
                        {data?.datos_traslado?.dam_ds ? 'Sí' : 'No'}
                    </CardRow>
                    <CardRow label="Indicador registro vehículos y conductores:" valueNowrap>
                        {data?.datos_traslado?.conductores_transp ? 'Sí' : 'No'}
                    </CardRow>
                    <CardRow label="Indicador traslado en contenedor manifiesto:" valueNowrap>
                        {data?.datos_traslado?.manifiesto_carga ? 'Sí' : 'No'}
                    </CardRow>
                </div>

                <div className={idStyles.modalSubtitle}>Vehículo principal</div>
                <div className={idStyles.compactGrid}>
                    <CardRow label="TUCE:">{data?.vehiculo_principal?.tuce ?? '-'}</CardRow>
                    <CardRow label="Placa:">{data?.vehiculo_principal?.placa ?? '-'}</CardRow>
                    <CardRow label="Conductor:">
                        {`${conductorNombre} (${conductorDni})`}
                    </CardRow>
                    <CardRow label="Licencia:">{data?.conductor_principal?.licencia ?? '-'}</CardRow>
                </div>

                <div className={idStyles.modalSubtitle}>Datos transportista</div>
                <div className={idStyles.compactGrid}>
                    <CardRow label="Número de registro MTC:">{data?.datos_transportista?.mtc ?? '-'}</CardRow>
                    <CardRow label="RUC:">{data?.datos_transportista?.ruc ?? '-'}</CardRow>
                    <CardRow label="Razón Social:" span2>
                        {data?.datos_transportista?.nombre ?? '-'}
                    </CardRow>
                </div>

                <div className={idStyles.compactGrid}>
                    <CardRow label="Observaciones:" span2 column>
                        {data?.observaciones ?? '-'}
                    </CardRow>
                </div>

                <div className={idStyles.modalSubtitle}>Documentos relacionados</div>
                <table className={idStyles.modernTable}>
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Número</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!data?.documentos_relacionados?.length ? (
                            <tr>
                                <td colSpan={2} className={idStyles.emptyCell}>
                                    -
                                </td>
                            </tr>
                        ) : (
                            data.documentos_relacionados.map((item, key) => (
                                <tr key={key}>
                                    <td>{item?.tipo === '01' ? 'Factura' : '-'}</td>
                                    <td>{item?.id ?? '-'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                <div className={idStyles.modalSubtitle}>Bienes</div>
                <table className={idStyles.modernTable} style={{ marginBottom: 0 }}>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Unidad</th>
                            <th>C.GTIN</th>
                            <th>C.SUNAT</th>
                            <th>Normalizado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!data?.bienes?.length ? (
                            <tr>
                                <td colSpan={7} className={idStyles.emptyCell}>
                                    -
                                </td>
                            </tr>
                        ) : (
                            data.bienes.map((item, key) => (
                                <tr key={key}>
                                    <td>{item?.codigo ?? '-'}</td>
                                    <td>{item?.description ?? '-'}</td>
                                    <td>{item?.cantidad ?? '-'}</td>
                                    <td>{item?.unidad_medida ?? '-'}</td>
                                    <td>{item?.codigo_gtin ?? '-'}</td>
                                    <td>{item?.codigo_sunat ?? '-'}</td>
                                    <td>{item?.normalizado ? 'Sí' : 'No'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </Modal>
    );
}
